import React from 'react'
import Yup from '../../../../../helpers/custom-yup'
import Title from '../../../../../components/typography/title.component'
import Button from '../../../../../components/buttons/buttons.component'
import moment from 'moment'
import PeriodInputs from '../../../../../components/form-components/period-inputs.component'
import InnerPageContainer from '../../../../../components/layout/private/inner-page-container.component'
import StyledSectionHeader from '../../../../../components/layout/styles/styled-section-header.style'
import PaginationComponent from '../../../../../components/pagination/pagination.component'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { UserService } from '../../../../../services/user.service'
import { AdminService } from '../../../../../services/admin.service'
import { toastActions } from '../../../../../actions/toast.actions'
import { RoleConstants } from '../../../../../constants'
import { BlockchainService } from '../../../../../services/blockchain.service'
import { bindActionCreators } from 'redux'
import { AdminReportsService } from '../../../../../services/admin-reports.service'
import * as pointsExtractActions from './points-extract.actions'
import { StyledForm, StyledPoints } from './styles.style'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import {
	SelectInput,
	AsyncSelectInput
} from '../../../../../components/form-components/inputs.component'
import ReactTooltip from 'react-tooltip'


class PointsExtractReportPageComponent extends React.Component {

	constructor(props) {
		super(props)

		this.renderRow = renderRow.bind(this)
		this.state = {
			dataTip: ''
		}
	
	}

	state = {
		moveflexNumber: '',
		accountChanged: true,
		period: 30,
		initialDate: moment()
			.add(-30, 'd')
			.format('DD/MM/YYYY'),
		finalDate: moment().format('DD/MM/YYYY'),
		transactionType: '',
		dataTip: ''
	}

	isExporting = false

	schema = Yup.object().shape({
		moveflexNumber: Yup.number().required('Informe uma conta')
	})

	params = {}

	onSubmit = ({ moveflexNumber, initialDate, finalDate, transactionType }) => {
		this.params = {
			moveflexNumber,
			initialDate,
			finalDate,
			type: transactionType
		}

		const { warning, exportData } = this.props
		const momentInitialDate = moment(initialDate, 'YYYY-MM-DD')
		const momentFinalDate = moment(finalDate, 'YYYY-MM-DD')

		if (momentFinalDate.isAfter(moment())) {
			warning({
				message: 'A data final não pode ser maior que a data atual'
			})
			return
		}

		if (momentInitialDate.isAfter(momentFinalDate)) {
			warning({
				message: 'A data inicial não pode ser maior que a data final'
			})
			return
		}

		const momentMinDate = moment()
			.subtract(60, 'months')
			.subtract(1, 'days')

		if (momentInitialDate.isBefore(momentMinDate)) {
			warning({
				message: 'O período máximo para consulta de extrato é de 60 meses'
			})
			return
		}

		if (this.isExporting) {
			this.isExporting = false
			exportData(this.params)
		} else {
			this.setState(
				{
					accountChanged: false
				},
				() => {
					this.refs.pagination.reload()
				}
			)
		}
	}

	searchedUserIsClient = () =>
		this.props.searchedUser &&
		this.props.searchedUser.roles &&
		this.props.searchedUser.roles.includes(RoleConstants.Client)

	onValueChange = (moveflexNumber, setFieldValue) => {
		this.setState(
			{
				accountChanged: true
			},
			() => {
				if (moveflexNumber == undefined || moveflexNumber == '') {
					this.props.setSearchedUser({})
					return
				}

				Promise.all([
					BlockchainService.getPoints(moveflexNumber),
					AdminService.getPointsToExpireNextThirthDays(moveflexNumber)
				]).then(values => {
					const roles = this.getRoleByNumber(moveflexNumber)
					this.props.setSearchedUser({
						name: this.getNameByNumber(moveflexNumber),
						moveflexNumber,
						points: values[0].data,
						expiringPoints: values[1].data,
						roles
					})
					if (
						UserService.getMostImportantRole(roles) !=
						RoleConstants.Client
					) {
						setFieldValue('transactionType', '')
					}
				})
			}
		)
	}

	getNameByNumber = number => {
		return this.props.options.filter(option => option.value === number)[0]
			.label
	}

	getRoleByNumber = number => {
		return this.props.options.filter(option => option.value === number)[0]
			.roles
	}

	loadOptions = (inputValue, callback) => {
		const { addOptions } = this.props

		AdminService.searchUsersToGetPointsExtract(inputValue).then(
			({ data }) => {
				addOptions(
					data.map(({ moveflexNumber, data, roles }) => ({
						value: moveflexNumber,
						label: data,
						roles
					}))
				)
				callback(
					data.length
						? data.map(({ moveflexNumber, data }) => ({
							value: moveflexNumber,
							label: data
						}))
						: null
				)
			}
		)
	}

	render() {
		const { searchedUser } = this.props
		const { accountChanged, dataTip } = this.state
		const { moveflexNumber, initialDate, finalDate, type } = this.params
		const isClient = this.searchedUserIsClient()
		return (
			<InnerPageContainer>
				<Title>Relatório de extrato de pontos</Title>
				<StyledSectionHeader>Filtros</StyledSectionHeader>
				<Formik
					ref="form"
					initialValues={this.state}
					onSubmit={this.onSubmit}
					validationSchema={this.schema}
					render={props => (
						<StyledForm noValidate onSubmit={props.handleSubmit}>
							<div className="col1">
								<AsyncSelectInput
									className="async-select-field"
									label="Conta *"
									id="moveflexNumber"
									loadOptions={this.loadOptions}
									onValueChange={value =>
										this.onValueChange(value, props.setFieldValue)
									}
									{...props}
								/>

								<PeriodInputs
									initialDate={this.state.initialDate}
									finalDate={this.state.finalDate}
									{...props}
								/>

								<SelectInput
									disabled={!isClient}
									id="transactionType"
									label="Tipo de transação"
									defaultValue={transactionTypeOptions[0]}
									options={transactionTypeOptions}
									multi={false}
									{...props}
								/>
							</div>
							<div
								style={{ display: 'flex', justifyContent: 'flex-end' }}>
								<Button
									secondary
									style={{ marginRight: '15px' }}
									type="button"
									onClick={() => {
										this.isExporting = true
										this.refs.form.submitForm()
									}}
									data-permission="52FCFB1ABC0591C1D6A0168A210F453D8954AA80">
									Exportar
								</Button>
								<Button
									data-permission="94DE282768B2D27C84FA668D3B8E971AA332DFF0"
									primary
									type="submit">
									Consultar
								</Button>
							</div>
						</StyledForm>
					)}
				/>
				{!accountChanged && (
					<StyledPoints>
						<div className="saldo">
							Saldo atual:{' '}
							<span className="blue">
								{Number(searchedUser.points).toLocaleString('pt-BR')}
							</span>
						</div>
						{/* <div className="expirando">
							Pontos expirando em 30 dias:{' '}
							<span className="orange">
								{Number(searchedUser.expiringPoints).toLocaleString(
									'pt-BR'
								)}
							</span>
						</div> */}
					</StyledPoints>
				)}
				{!!searchedUser && (
					<div
						style={{ marginTop: '20px', width: '100%' }}
						data-permission="94DE282768B2D27C84FA668D3B8E971AA332DFF0">
						<PaginationComponent
							dataTip={dataTip}
							ref="pagination"
							loadonce
							rowsPerPage={100}
							getData={AdminReportsService.searchExtractOfPoints}
							params={{ moveflexNumber, initialDate, finalDate, type }}
							headers={
								isClient ? clientPaginationHeaders : paginationHeaders
							}
							sortable={sortable}
							renderRow={this.renderRow}
						/>
						<ReactTooltip
							getContent={() => dataTip}
							type={'warning'}
							html={true}
						/>
					</div>
				)}
			</InnerPageContainer>
		)
	}
}

const transactionTypeOptions = [
	{ value: '', label: 'Todos' },
	{ value: 'Accumulation', label: 'Acúmulo de pontos' },
	{ value: 'Used', label: 'Resgate de pontos' },
	{ value: 'Expired', label: 'Expiração de pontos' }
]

const paginationHeaders = [
	{ header: 'Data transação', key: 'date' },
	{ header: 'Origem', key: 'source' },
	{ header: 'Destino', key: 'destination' },
	{ header: 'Produto', key: 'notes' },
	{ header: 'Pontos', key: 'value', align: 'right' },
	{ header: 'Data de vencimento', key: 'expirationDate', align: 'center' }
]

const clientPaginationHeaders = [
	{ header: 'Data transação', key: 'date', align: 'center' },
	{ header: 'Tipo', key: 'type' },
	{ header: 'Parceiro', key: 'broker' },
	{ header: 'Produto', key: 'notes' },
	{ header: 'Pontos', key: 'value', align: 'right' },
	{ header: 'Data de vencimento', key: 'expirationDate', align: 'center' }
]

const sortable = {
	defaultOrder: 'desc',
	cols: [
		{ key: 'date' },
		{ key: 'type' },
		{ key: 'value' },
		{ key: 'expirationDate' }
	]
}


function renderRow(rowData, headers) {
	const onMouseEnter = () => {
		const { trackNumber, tripDate, price } = rowData.extra || {};
		const dataTip2 = rowData.extra
			? `
		<p>
		  Localizador: ${trackNumber}
		  <br />
		  Data da viagem: ${tripDate}
		  <br />				
		  Valor: ${price.$toReais()}
		</p>`
			: '';

		this.setState({
			dataTip: dataTip2
		});
	};

	return headers.map(({ key, align }) => (
		<td onMouseEnter={onMouseEnter} key={key} align={align}>
			<span
				title={rowData[key]}
				className={
					key === 'value'
						? `${rowData['isCredit'] ? 'blue' : 'danger'}`
						: ''
				}>
				{key === 'value'
					? Number(rowData[key]).toLocaleString('pt-BR')
					: rowData[key] || ''}
			</span>
		</td>
	));
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions,
			...pointsExtractActions
		},
		dispatch
	)

const mapStateToProps = ({ adminPointsExtractReport }) => {
	return {
		...adminPointsExtractReport
	}
}

const connectedPointsExtractReportPageComponent = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(PointsExtractReportPageComponent)
)

export { connectedPointsExtractReportPageComponent as ModuleRootComponent }
